<template>
  <div class="relative overflow-hidden rounded-sm bg-white shadow-[0px_4px_96px_0px_rgba(0,0,0,0.15)]">
    <NuxtLink class="group block font-Spectral text-gray9" :to="detailPath" @click="onCtaClick">
      <div class="aspect-[361/241] w-full overflow-hidden bg-gray5">
        <OptimizedImage
          v-if="pin.thumbnailImageUrl"
          alt=""
          class="h-full w-full object-cover transition-transform duration-300 md:group-hover:scale-105"
          :image-url="pin.thumbnailImageUrl"
          :optimized-image-options="{ width: 560 }"
        />
      </div>
      <div class="flex flex-col gap-1 px-3 py-2">
        <p class="line-clamp-3 text-[16px] leading-6 text-gray9 md:group-hover:text-gold3">{{ pin.name }}</p>
        <div class="flex flex-wrap items-center gap-x-1 text-gray4">
          <template v-if="pin.area">
            <span class="text-[14px] leading-5">{{ pin.area }}</span>
            <span class="text-[12px] leading-4">|</span>
          </template>
          <span class="flex items-center gap-0.5">
            <img alt="" class="h-4 w-4" src="@/assets/icon/wabunka/clock-gray500.svg" />
            <span class="text-[14px] leading-5">{{ pin.experienceDuration?.value }}</span>
            <span class="text-[12px] leading-4">{{ pin.experienceDuration?.unit }}</span>
          </span>
          <template v-if="priceLabel">
            <span class="text-[12px] leading-4">|</span>
            <span class="text-[14px] leading-5">{{ priceLabel }}</span>
          </template>
        </div>
      </div>
    </NuxtLink>
    <button
      aria-label="Close preview"
      class="absolute right-2 top-2 flex h-8 w-8 items-center justify-center rounded-full bg-white/90 text-gray4 shadow-[0px_4px_48px_0px_rgba(0,0,0,0.15)]"
      type="button"
      @click="onClose"
    >
      <svg aria-hidden="true" class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18" stroke-linecap="round" /></svg>
    </button>
  </div>
</template>

<script setup lang="ts">
import { OptimizedImage } from '@/wabunka-src/common/components';
import { buildMapPinPriceLabel, type WabunkaExperienceMapPinViewModel } from '@/wabunka-src/common/features/Experience/models/wabunkaExperienceMapPin';
import { buildExperienceDetailPath } from '@/wabunka-src/common/features/Experience/utils/experienceDetailPath';

interface Props {
  pin: WabunkaExperienceMapPinViewModel;
  /** プレビューを閉じるコールバック */
  onClose?: () => void;
  /** カードから体験詳細へ遷移したときのコールバック（GA 計測用） */
  onCtaClick?: () => void;
}

const props = defineProps<Props>();

const priceLabel = computed<string>(() => buildMapPinPriceLabel(props.pin));
const detailPath = computed<string>(() => buildExperienceDetailPath(props.pin.slug));
</script>
